<template>
  <div :style="style" ref="container">
    <Signature
      :name="name"
      :closable="closable"
      @close="$emit('close')"
    />
  </div>
</template>

<script>

import Signature from '@/febos/global/pdf/components/Signature';
import SignatureBehaviors from '@/febos/global/pdf/mixins/SignatureBehaviors';

export default {
  mixins: [SignatureBehaviors],
  components: {
    Signature,
  },
  props: {
    name: { type: String },
    closable: { type: Boolean, default: false }
  }
};

</script>
